export default {
  selectedItemList: [],
  selectedItemIndex: 0,
  selectedItemAmount: null,
  __typename: 'NutritionStatusGrocery'
};
